import { Tab, Tabs, Box } from '@mui/material'
import { useState } from 'react'
import { WrapperTable } from '../components'
import TabConfPorSector from './TabConfPorSector'
import TabConfPorSistema from './TabConfPorSistema'

function ConfigSectorSistemaGrupo() {
    const [tab, setTab] = useState(0)

    return (
        <WrapperTable>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <Tabs value={tab} onChange={(_, v) => setTab(v)}>
                    <Tab label='Conf. por Sector' />
                    <Tab label='Conf. por Sistema' />
                </Tabs>
            </Box>
            {tab === 0 && <TabConfPorSector />}
            {tab === 1 && <TabConfPorSistema />}
        </WrapperTable>
    )
}

export default ConfigSectorSistemaGrupo
